import {FormatMessageFunction, LinkProp} from '../../../types';

export const getMenuLinks = (formatMessage: FormatMessageFunction): LinkProp[] => {
  const menuLinks = [
    {
      label: formatMessage({id: 'footer.column.businessLoans.link'}),
      href: formatMessage({id: 'footer.column.businessLoans.href'}),
      testId: 'ui.footer.link.businessLoans',
    },
    {
      label: formatMessage({id: 'footer.column.FAQ.link'}),
      href: formatMessage({id: 'footer.column.FAQ.href'}),
      testId: 'ui.footer.link.faq',
    },
    {
      label: formatMessage({id: 'footer.column.careers.link'}),
      href: formatMessage({id: 'footer.column.careers.href'}),
      testId: 'ui.footer.link.careers',
    },
  ];
  return menuLinks;
};

export const getLegalLinks = (formatMessage: FormatMessageFunction): LinkProp[] => {
  const legalLinks = [
    {
      label: formatMessage({id: 'footer.column.termsOfService.link'}),
      href: formatMessage({id: 'footer.column.termsOfService.href'}),
      testId: 'ui.footer.link.termsOfService',
    },
    {
      label: formatMessage({id: 'footer.column.treatingCustomersFairly.link'}),
      href: formatMessage({id: 'footer.column.treatingCustomersFairly.href'}),
      testId: 'ui.footer.link.treatingCustomersFairly',
    },
    {
      label: formatMessage({id: 'footer.column.complaints.link'}),
      href: formatMessage({id: 'footer.column.complaints.href'}),
      testId: 'ui.footer.link.complaints',
    },
  ];
  return legalLinks;
};

export const getInTouchLinks = (formatMessage: FormatMessageFunction): LinkProp[] => {
  const getInTouch = [
    {
      label: formatMessage({id: 'phoenix.contact.email'}),
      href: `mailto:${formatMessage({id: 'phoenix.contact.email'})}`,
      testId: 'ui.footer.link.contact',
    },
    {
      label: formatMessage({id: 'footer.column.getInTouch.telephone'}),
      href: `tel:${formatMessage({id: 'phoenix.contact.phoneNumber.withCountryCode'})}`,
      testId: 'ui.footer.link.getInTouch',
    },
  ];
  return getInTouch;
};
